import React, { forwardRef, useState } from "react";
import { Form, Button, Row } from "@masterteam/mt-design-react";

import { ReactComponent as CloseIcon } from "../../assets/images/close.svg";

import Tabs from "./Component/Tabs";
import Footer from "./Component/Footer";

export const { Field } = Form;

export function WizardStep({ children }) {
  return children;
}

function Wizard(
  {
    children,
    initialValues,
    onSubmit,
    closeModal,
    setIsDraft,
    isReadOnly,
    isAddKpiProcess,
  },
  ref
) {
  const [stepNumber, setStepNumber] = useState(0);
  const steps = React.Children.toArray(children);

  const [snapshot, setSnapshot] = useState(initialValues);

  const step = steps[stepNumber];
  const totalSteps = steps.length;
  const isLastStep = stepNumber === totalSteps - 1;

  const next = (values) => {
    setSnapshot(values);
    setStepNumber(Math.min(stepNumber + 1, totalSteps - 1));
  };

  const previous = (values) => {
    setSnapshot(values);
    setStepNumber(Math.max(stepNumber - 1, 0));
  };

  const handleSubmit = async (values, bag) => {
    if (step.props.onSubmit) {
      await step.props.onSubmit(values, bag);
    }
    if (isLastStep) {
      return onSubmit(values, bag);
    } else {
      bag.setTouched({});
      next(values);
    }
  };

  return (
    <Form
      innerRef={ref}
      initialValues={snapshot}
      onSubmit={handleSubmit}
      validationSchema={step.props.validationSchema}
    >
      {(formik) => (
        <>
          <Row
            justify="between"
            align="center"
            className="base-container"
            style={{ borderBottomColor: "var(--primary-color)" }}
          >
            <Tabs steps={steps} stepNumber={stepNumber} />
            {closeModal && (
              <Button
                onClick={() => {
                  closeModal();
                }}
                Icon={CloseIcon}
                shape="square"
                fill="none"
                variant="dark"
                className="close-container"
              />
            )}
          </Row>
          {React.cloneElement(step, { formBag: formik })}
          <Footer
            stepNumber={stepNumber}
            totalSteps={totalSteps}
            isLastStep={isLastStep}
            previous={previous}
            formik={formik}
            setIsDraft={setIsDraft}
            isAddKpiProcess={isAddKpiProcess}
            isReadOnly={isReadOnly}
          />
        </>
      )}
    </Form>
  );
}

export default forwardRef(Wizard);
